export function lineaTieneOrigenMaster(linea: {
  nroFormularioMaster?: number;
  nroItemMaster?: number;
}): boolean {
  const nfm = Number(linea.nroFormularioMaster);
  const nim = Number(linea.nroItemMaster);
  return Number.isFinite(nfm) && nfm > 0 && Number.isFinite(nim) && nim > 0;
}

/** Número comercial (letra-sucursal-comprobante) dentro de un texto de comprobante. */
export function numeroComercialDesdeDisplay(display?: string | null): string {
  const raw = (display ?? '').trim();
  if (!raw || raw === '-') return '';
  const match = raw.match(/[A-Za-z]-\d+-\d+/);
  return match ? match[0].toUpperCase() : '';
}

/** Números distintos de los pedidos que siguen en los renglones, en orden de aparición. */
export function numerosComercialesDeLineas(
  lineas: Array<{
    nroFormularioMaster?: number;
    nroItemMaster?: number;
    pendienteMeta?: { comprobanteDisplay?: string };
  }>,
): string[] {
  const vistos = new Set<string>();
  const numeros: string[] = [];
  for (const linea of lineas) {
    if (!lineaTieneOrigenMaster(linea)) continue;
    const numero = numeroComercialDesdeDisplay(linea.pendienteMeta?.comprobanteDisplay);
    if (!numero || vistos.has(numero)) continue;
    vistos.add(numero);
    numeros.push(numero);
  }
  return numeros;
}

/** El alta debe citar el pedido solo si un renglón vigente sigue apuntando a ese formulario. */
export function documentoOrigenSigueEnRenglones(
  nroFormulario: number | null | undefined,
  lineas: Array<{ nroFormularioMaster?: number; codigoArticulo?: string; cantidad?: number }>,
): boolean {
  const id = Number(nroFormulario);
  if (!Number.isFinite(id) || id <= 0) return false;
  return lineas.some((linea) => {
    const master = Number(linea.nroFormularioMaster);
    const cantidad = Number(linea.cantidad ?? 0);
    const codigo = String(linea.codigoArticulo ?? '').trim();
    return codigo.length > 0 && cantidad > 0 && Number.isFinite(master) && master === id;
  });
}
